import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSetFilterAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import { BaseObjectFilters } from '../../store/bootstrap';
import * as fromContactActions from './contact.actions';
import { Contact } from './contact.model';

export interface ContactFilters extends BaseObjectFilters {
    contactType: string;
}

export interface State {
    ids: Array<string>;
    entities: { [id: string]: Contact };
    filters: ContactFilters;
}

export const initialState: State = {
    ids: [],
    entities: {},
    filters: {
        searchTerm: '',
        contactType: '*',
        sortBy: 'name',
        sortDirection: 1
    }
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(state = initialState, action: fromContactActions.Actions): State {
    switch (action.type) {
        case fromContactActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromContactActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromContactActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromContactActions.SET_FILTER: {
            return handleSetFilterAction(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/contact/contact.reducer.ts